import { chainOrSuspend, pyNone } from "@Sk";
import PyDefUtils from "PyDefUtils";
import { AnvilHookSpec, Component, ComponentConstructor, HandleInteraction } from "@runtime/components/Component";
import { designerApi } from "@runtime/runner/component-designer-api";
import { BASE_MODULES } from "../python-environment";

const { DesignXYPanel, XYPanel } = BASE_MODULES["anvil"];

const clamp = (val: number, minV: number, maxV: number) => Math.max(Math.min(val, maxV), minV);

const mkDesignerHookSpec = (oldHookSpec: AnvilHookSpec): Partial<AnvilHookSpec> => {
    return {
        enableDropMode(dragging) {
            const element = this._anvil.elements.holder;
            const panelOffset = element.getBoundingClientRect();
            return [
                {
                    element,
                    expandable: false,
                    freePlacement: (dropping) => {
                        const landing = dropping.map(({ x, y, width, height }) => ({
                            x: clamp(x, 0, panelOffset.width - (width ?? 200)),
                            y: clamp(y, 0, panelOffset.height - (height ?? 20)),
                            width: Math.min(width ?? 200, panelOffset.width),
                            height: height ?? 20,
                        }));
                        return {
                            dropLocations: landing,
                            dropInfo: {
                                perComponentUpdates: landing.map(({ x, y, width }) => ({
                                    layout_properties: { x, y, width },
                                })),
                            },
                        };
                    },
                },
            ];
        },
        disableDropMode: () => {},
        getContainerDesignInfo(forChild) {
            const oldHandles = this._anvil.getHandles(forChild);
            return {
                layoutPropertyDescriptions: [
                    {
                        name: "x",
                        type: "number",
                        description: "The name of the content slot where the component will be placed",
                    },
                    {
                        name: "y",
                        type: "number",
                        description: "The name of the content slot where the component will be placed",
                    },
                    {
                        name: "width",
                        type: "number",
                        description: "The width for an element that is not horizontally self-sizing",
                    },
                ],
                interactions: oldHandles.map((h: any): HandleInteraction => {
                    h.pyChild = forChild;
                    let grabData: any = null;
                    return {
                        type: "handle",
                        position: "right",
                        direction: "x",
                        callbacks: {
                            grab: () => {
                                grabData = this._anvil.handleGrab(h, 0, 0);
                            },
                            drag: (dx, dy) => {
                                this._anvil.handleDrag(h, grabData, dx, dy, false);
                            },
                            drop: (dx, dy) => {
                                const { layoutProperties } = this._anvil.handleDrop(h, grabData, dx, dy);
                                designerApi.updateComponentProperties(forChild, {}, layoutProperties["undefined"]);
                            },
                        },
                    };
                }),
            };
        },
    };
};

export const DesignXYPanelV3 = Sk.misceval.buildClass(
    BASE_MODULES["anvil"],
    ($gbl, $loc) => {
        const oldHookSpec = XYPanel.prototype.anvil$hookSpec;
        $loc.anvil$hookSpec = Object.assign(Object.create(oldHookSpec), mkDesignerHookSpec(oldHookSpec));
    },
    "DesignXYPanelV3",
    [DesignXYPanel]
) as ComponentConstructor;
